import { render, staticRenderFns } from "./ButtonAddFile.vue?vue&type=template&id=9f024b44"
import script from "./ButtonAddFile.vue?vue&type=script&lang=js"
export * from "./ButtonAddFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports